import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getCountry, getLanguageFromCountry } from '@/plugins/country/module';

Vue.use(VueI18n);

// Import texts
import textsSV from './locales/sv-SE.json';
import textsNL from './locales/nl-NL.json';
import textsDE from './locales/de-DE.json';
import textsDK from './locales/da-DK.json';
import textsEN from './locales/en-US.json';

// Import paths
import pathsSE from './locales/paths/SE.json';
import pathsNL from './locales/paths/NL.json';
import pathsDE from './locales/paths/DE.json';
import pathsDK from './locales/paths/DK.json';

// Paths (path_*) and URLs (url_*) belong to the site's country, not to the
// language the texts are shown in. Every language therefore carries the
// current country's paths, so the developer menu can switch language at
// runtime (src/i18n/uiLocale.js) without breaking links or API calls.
const countryPaths = {
  se: pathsSE,
  nl: pathsNL,
  de: pathsDE,
  dk: pathsDK
}[getCountry()];

// Locale that shows each text's key instead of the text (developer menu).
export const TRANSLATION_KEYS = 'keys';

const messages = {
  sv: {
    ...textsSV,
    ...countryPaths
  },
  nl: {
    ...textsNL,
    ...countryPaths
  },
  de: {
    ...textsDE,
    ...countryPaths
  },
  da: {
    ...textsDK,
    ...countryPaths
  },
  en: {
    ...textsEN,
    ...countryPaths
  },
  [TRANSLATION_KEYS]: {
    ...countryPaths
  }
};

const lang = getLanguageFromCountry();

document.documentElement.setAttribute('lang', lang);

export const routeLocale = lang;
Vue.prototype.$routeLocale = routeLocale;

export default new VueI18n({
  locale: lang,
  fallbackLocale: 'en',
  messages
});
